// Import the singleton instance from the main app instead of creating a new one
import { supabase as mainSupabaseClient } from '../../../lib/supabaseClient';
import { createClient } from '@supabase/supabase-js';

// Use the existing Supabase configuration from the main app
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
const supabaseServiceRoleKey = import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY;

// Log the configuration status (not the actual values for security)
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase configuration missing. Please check your environment variables.');
}

// Use the singleton client from the main app instead of creating a new one
export const supabase = mainSupabaseClient;

// Only create admin client if service role key is available
export const supabaseAdmin = supabaseServiceRoleKey 
  ? createClient(supabaseUrl, supabaseServiceRoleKey)
  : null;

/**
 * Helper function to handle Supabase errors
 * @param error Supabase error object
 * @param defaultMessage Default error message
 * @returns Formatted error message
 */
export const handleSupabaseError = (error: any, defaultMessage = 'An unexpected error occurred'): string => {
  if (!error) return defaultMessage;
  
  // Handle specific error codes
  if (error.code === 'PGRST116') {
    return 'Resource not found';
  }
  
  // Return the error message or the default message
  return error.message || error.error_description || defaultMessage;
};
